<template>
  <div class="mainChild page-content" id="synchronizeSettings">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>业务设置</el-breadcrumb-item>
        <el-breadcrumb-item>同步每日违规置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="background-color: #fff;padding: 20px;font-size: 15px;">
      <el-tabs v-model="platform" type="card" @tab-click="handleClick">
        <el-tab-pane label="淘宝天猫" name="TBTM"></el-tab-pane>
        <el-tab-pane label="京东商城" name="JD"></el-tab-pane>
        <el-tab-pane label="苏宁易购" name="SN"></el-tab-pane>
        <el-tab-pane label="当当网" name="DD"></el-tab-pane>
        <el-tab-pane label="1688网" name="1688"></el-tab-pane>
        <el-tab-pane label="拼多多" name="PDD"></el-tab-pane>
      </el-tabs>

      <div style="border-radius: 16px;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding: 20px;" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

        <div style="display: flow-root;">
          <div class="settingYellowStyle" style="float: left;" v-if="status === '1'">
            <img src="../../assets/img/other/trumpet_icon.png" style="margin-right: 5px;">
            <span>
              设置完成后未设置到的链接自动设置成相对的整改形式。
            </span>
          </div>
          <div class="settingYellowStyle" style="float: left;" v-else>
            <img src="../../assets/img/other/trumpet_icon.png" style="margin-right: 5px;">
            <span>
              如若需要使用该功能请在右侧点击开关按钮。
            </span>
          </div>
          <div style="float: right;margin-right: 16px;">
            <el-switch
              @change="saveSetting"
              v-model="status"
              active-text="开" active-value="1"
              inactive-text="关" inactive-value="0"
              >
            </el-switch>
          </div>
        </div>

        <el-form label-width="79px" style="margin-top: 16px;" v-if="status === '1'">
          <el-form-item label="整改形式" :required="true">
            <el-radio-group v-model="rectificationform" @change="deleteSetting(4)">
              <el-radio label="1">通知下架</el-radio>
              <el-radio label="0">通知改价</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="整改设置" :required="true">
            <el-radio-group v-model="setting" @change="deleteSetting(4)">
              <el-radio label="4">全部</el-radio>
              <el-radio label="3">店铺状态设置</el-radio>
              <el-radio label="1">整改店铺设置</el-radio>
              <el-radio label="2">整改产品设置</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div style="border-radius: 16px;margin-bottom: 16px;box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding: 20px;" v-for="item in nameTypeStatus" v-if="status === '1' && setting == item.setting">
          <div style="display: flow-root;">
            <div style="float: left;line-height: 40px;">
              {{item.name}}
            </div>
            <div style="float: right;margin-right: 16px;">
              <el-button type="text" @click="nameType(item.type)">编辑</el-button>
              <el-button type="text" @click="deleteSetting(item.type)">清除</el-button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <el-dialog title="店铺状态编辑" :visible.sync="editorShow" width="360px" style="margin-top: 10%;">
      <el-form>
        <el-form-item label="店铺状态" label-width="100" :required="true">
          <el-select size="small" clearable v-model="shoptypesetting" placeholder="请选择">
            <el-option
              v-for="item in shopType"
              :key="item.type"
              :value="item.type"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSetting(3)" size="small">确 定</el-button>
        <el-button @click="editorShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
  		title='整改店铺编辑'
  		:visible.sync="setShopShow"
  		:close-on-click-modal="false"
  		width="960px">
  		<el-transfer
  			filterable
  			:filter-method="filterMethod"
  			filter-placeholder="请输入店铺名称"
  			v-model="valueIndex"
  			:button-texts="['到左边', '到右边']"
  			:titles="['选择店铺', '已选店铺']"
  			:data="transferData"
  			@change="leftChange"
  			>
  		</el-transfer>
  		<span slot="footer">
        <el-button size="small" type="primary" @click="shopClick(1)">保 存</el-button>
  			<el-button size="small" type="TheCustom" @click="setShopShow = false">关 闭</el-button>
  		</span>
  	</el-dialog>
    <childMonitoring ref="childMonitoring" @selectedfirm="onComfirm" @fatherBlur="inputBlur"/>
  </div>
</template>
<script>
import childMonitoring from "../../components/childMonitoring/childMonitoring.vue";
export default {
  name: "synchronizeSettings",
  data() {
    return {
      setting: '4',
      platform: 'TBTM',
      status: '0',
      rectificationform: '1',
      nameTypeStatus: [{
        name: '店铺状态设置',
        type: '3',
        setting: '3',
      },{
        name: '整改店铺设置',
        type: '1',
        setting: '1',
      },{
        name: '整改产品设置',
        type: '2',
        setting: '2',
      }],
      id: '',
      loading: false,
      editorShow: false,
      shoptypesetting: '',
      shopType: [{
        name: '授权店铺',
        type: '授权店铺',
      },{
        name: '灰名单',
        type: '灰名单',
      },{
        name: '黑名单',
        type: '黑名单',
      }],
      setShopShow: false,
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      valueIndex: [],
      transferData: [],
      valueData: [],
      editType: '',
      productsData: [],
    };
  },
  components: {
    childMonitoring
  },
  mounted() {
    this.iprViolationRetrievsettingdetails()
  },
  computed: {

  },
  methods: {
    // 标签页触发
    handleClick(tab, event) {
      this.platform = tab.name
      console.log(123)
      this.status = '0'
      this.rectificationform = '1'
      this.iprViolationRetrievsettingdetails()
    },
    // 初始化详情
    iprViolationRetrievsettingdetails() {
      this.loading = true
      let params={
        platform: this.platform,
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/iprViolationRetrievsettingdetails",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.id = ''
          if (!res.data) {
            this.status = '0'
            this.rectificationform = '1'
          } else {
            this.id = res.data.id
            if (res.data.status) {
              this.status = res.data.status.toString()
            }
            if (res.data.rectificationform || res.data.rectificationform == 0) {
              this.rectificationform = res.data.rectificationform.toString()
            }
            if (res.data.settingtype) {
              this.setting = res.data.settingtype
            } else {
              this.setting = '4'
            }

            this.shoptypesetting = res.data.shoptypesetting
          }
          this.loading = false
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    // 开关
    saveSetting(e) {
      let data={
        platform: this.platform,
        status: this.status,
        rectificationform: this.rectificationform,
        settingtype: this.setting
      }
      if (this.id) {
        data.id = this.id
      }
      if (e == 3) {
        if (!this.shoptypesetting) {
          this.$message({
            message: '请选择店铺状态',
            type: 'warning'
          });
          return
        }
        data.rectificationform = this.rectificationform
        data.shoptypesetting = this.shoptypesetting
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/saveSetting",
        method: "post",
				data: JSON.stringify(data),
				headers: {
					'Content-Type': 'application/json',
				},
				noFormat: false,
				responseType: "json"
      }).then(result => {
        let res = result;
        let {data}=res
        if(res.status == '10000'){
          // 新增之后需要操作id
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.id = ''
          this.id = res.data.id
          this.editorShow = false
          this.iprViolationRetrievsettingdetails()
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    // 清除
    deleteSetting(type) {
      let params={
        platform: this.platform,
      }
      console.log(type)
      if (type != 4) {
        params.type = type
        params.ids = this.id
      } else {
        params.ids = 'checkAll'
        params.rectificationform = this.rectificationform
        params.settingtype = this.setting
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/deleteSetting",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        if(res.status == '10000'){
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.iprViolationRetrievsettingdetails()
        } else {
          console.log(res)
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    // 打开详情弹框
    nameType(type) {
      this.editType = type
      if (type == 3) {
        this.editorShow = true
        this.iprViolationRetrievsettingdetails()
      } else if (type == 1) {
        this.iprViolationRetrievSettingdetailslist(1)
      } else {
        this.iprViolationRetrievSettingdetailslist(2)
      }
    },
    iprViolationRetrievSettingdetailslist(type) {
      let params={
        platform: this.platform,
        type: type,
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/iprViolationRetrievSettingdetailslist",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          if (type == 1) {
            this.getPageByBmcs(res.data)
          } else {
            this.productsData = []
            if (res.data.length != 0) {
              for (let a in res.data) {
                this.productsData.push({
                  productid: res.data[a].productid,
                  name: res.data[a].productname,
                  price: 0
                })
              }
            }
            this.newAdd()
          }
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    // 选择店铺编辑
    leftChange(left,right) {
      let idsArr = []
      if (left instanceof Array) {
        this.valueIndex = left
      } else {
        this.valueIndex = right
      }
      if (this.valueIndex && this.valueIndex.length != 0) {
        for (let b in this.valueIndex) {
          idsArr.push(this.contentArr[this.valueIndex[b]].id)
        }
      }
      this.valueData = []
      for (let a in this.contentArr) {
        for (let e in idsArr) {
          if (this.contentArr[a].id == idsArr[e]) {
            this.valueData.push({
              rectificationform: Number(this.rectificationform),
              type: Number(this.editType),
              shopid: this.contentArr[a].id,
              shopname: this.contentArr[a].shopName,
              mainid: this.id,
              platform: this.platform,
            })
          }
        }
      }
    },
    // 获取店铺编辑数据
    getPageByBmcs(data){
      let params = {
        // pageSize: 5000,
        // pageNo: 1,
        shopname: '',
      }
      if (this.platform) {
        params.platform = this.platform
      }
      fetch({url: "hcm/hcmShop/finShopByNameal", method: "get", params}).then((res)=>{
        this.contentArr = []
        this.valueIndex = []
        this.valueData = []
        if (res.data && res.data.length != 0) {
          if (this.platform == 'TBTM') {
            for (let a in res.data) {
              if (res.data[a].shopName) {
                this.contentArr.push({
                  shopName: res.data[a].shopName + ' ' +res.data[a].wangwang + " (旺旺)",
                  id: res.data[a].id
                })
              }
            }
          } else {
            for (let a in res.data) {
              this.contentArr.push({
                shopName: res.data[a].shopName + ' ' +res.data[a].shopName,
                id: res.data[a].id
              })
            }
          }
          this.generateData(data)
        }
      })
    },
    // 店铺编辑数据处理
    generateData(data) {
      this.transferData = [];
      this.contentArr.forEach((city, index) => {
        this.transferData.push({
          label: city.shopName,
          key: index,
        });
      });
      this.setShopShow = true
      if (data.length != 0 && this.transferData.length != 0) {
        for (let a in this.contentArr) {
          for (let b in data) {
            if (this.contentArr[a].id === data[b].shopid) {
              this.valueIndex.push(Number(a))
              this.valueData.push({
                rectificationform: Number(this.rectificationform),
                type: Number(this.editType),
                shopid: this.contentArr[a].id,
                shopname: this.contentArr[a].shopName,
                mainid: this.id,
                platform: this.platform,
              })
            }
          }
        }
      }
      return this.transferData;
    },
    // 新增整改产品
    newAdd() {
      let params = {
        pageNum: 1,
        pageSize: 10000,
      }
      fetch({
        url: "hcm/ProductClassify/seletProductClassify",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          let typeNum = 2
          this.$refs.childMonitoring.open(typeNum,res.data.data.list,this.productsData)
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    // 确认整改店铺
    shopClick(e) {
      let data
      if (e == 1) {
        data = this.valueData
        if (this.valueData.length == 0) {
          this.$message({
            message: '请添加数据',
            type: 'warning'
          });
          return
        }
      } else {
        data = this.productsData
        if (this.productsData.length == 0) {
          this.$message({
            message: '请添加数据',
            type: 'warning'
          });
          return
        }
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/saveSettingdetails",
        method: "post",
				data: JSON.stringify(data),
				headers: {
					'Content-Type': 'application/json',
				},
				noFormat: false,
				responseType: "json"
      }).then(result => {
        let res = result;
        let {data}=res
        if(res.status == '10000'){
          if (e == 1) {
            this.setShopShow = false
          }
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.iprViolationRetrievsettingdetails()
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    // 子传父
    onComfirm(data) {
      this.productsData = []
      if (data.length != 0) {
        for (let a in data) {
          this.productsData.push({
            rectificationform: Number(this.rectificationform),
            type: Number(this.editType),
            productid: data[a].productid,
            productname: data[a].name,
            mainid: this.id,
            platform: this.platform,
          })
        }
        this.shopClick(2)
      }
    },
    // 子组件搜索
    inputBlur() {
      console.log('调用')
      this.newAdd()
    },






  }
};
</script>

<style lang="scss">
  #synchronizeSettings {
    .settingYellowStyle {
      padding: 8px;
      background-color: #fdf6ec;
      border-color: #faecd8;
      color: #e6a23c;
      border-width: 1px;
      border-style: solid;
      border-radius: 4px;
      width: 400px;
    }
    .el-transfer {
	    font-size: 14px;
	    height: 500px !important;
	  }
	  .el-transfer-panel {
	    width: 324px !important;
	    height: 500px !important;
	  }
	  .el-transfer-panel__list.is-filterable {
	    height: 396px !important;
	  }
  }
</style>
